<app-admin-header></app-admin-header>
<div class="log-container">
  <app-admin-sidebar></app-admin-sidebar>

  <h2>📦 Product Log</h2>

  <div class="dropdown-wrapper">
    <label for="product-search">Select Product:</label>
    <input
      id="product-search"
      type="text"
      placeholder="Search product..."
      [(ngModel)]="searchTerm"
      (focus)="isDropdownOpen = true"
      (blur)="onBlurDropdown()"
    />

    <ul class="dropdown-list" *ngIf="isDropdownOpen && filteredStockItems.length">
      <li *ngFor="let item of filteredStockItems" (mousedown)="selectProduct(item)">
        {{ item.name }}
      </li>
    </ul>
  </div>

  <div *ngIf="selectedId">
    <div class="filters">
      <label>From:</label>
      <input type="date" [(ngModel)]="startDate" />
      <label>To:</label>
      <input type="date" [(ngModel)]="endDate" />
    </div>

    <h3>🗃️ Stock Entries for <span class="highlight">{{ productName }}</span></h3>
    <table *ngIf="filteredEntries.length > 0" class="responsive-table">
      <thead>
        <tr>
          <th>Store</th>
          <th>Quantity</th>
          <th>Note</th>
          <th>Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let entry of filteredEntries">
          <td><span class="label">Store:</span> <span class="value">{{ entry.store_name }}</span></td>
          <td><span class="label">Quantity:</span> <span class="value">{{ entry.quantity }}</span></td>
          <td><span class="label">Note:</span> <span class="value">{{ entry.note || '—' }}</span></td>
          <td><span class="label">Date:</span> <span class="value">{{ entry.created_at | date: 'short' }}</span></td>
        </tr>
      </tbody>
    </table>

    <p *ngIf="filteredEntries.length === 0">No stock entries in this date range.</p>

    <h3>💊 Issued Drugs</h3>
    <table *ngIf="filteredIssues.length > 0" class="responsive-table">
  <thead>
    <tr>
      <th>Patient</th>
      <th>Store</th>
      <th>Quantity</th>
      <th>Note</th>
      <th>Date</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let issue of filteredIssues">
      <td><span class="label">Patient:</span> <span class="value">{{ issue.patient_name }}</span></td>
      <td><span class="label">Store:</span> <span class="value">{{ issue.store_name }}</span></td>
      <td><span class="label">Quantity:</span> <span class="value">{{ issue.quantity }}</span></td>
      <td><span class="label">Note:</span> <span class="value">{{ issue.note || '—' }}</span></td>
      <td><span class="label">Date:</span> <span class="value">{{ issue.created_at | date: 'short' }}</span></td>
    </tr>
  </tbody>
    </table>

    <p *ngIf="filteredIssues.length === 0">No drug issues in this date range.</p>
  </div>
</div>
